// @flow
import { HIGHLIGHT } from 'Client/cms/toolkit/constants';
import { HighlightLine } from 'Components/lines/highlight-line/HighlightLine';

export const highlightDescriptor = {
  name: HIGHLIGHT,
  component: HighlightLine,
};
